import React from 'react'
import Sidebar from '../../../components/sidebar';
import Navbar from '../../../components/navbar';
import Footer from '../../../components/footer';
import LogoutModel from '../../../components/Models/LogoutModel';
import MarketPLTable from './MarketPLTable';


const MarketPL = () => {
  return (
    <div>
      {/* Page Wrapper */}
      <div id="wrapper">
        {/* Sidebar */}
        <Sidebar />
        {/* Content Wrapper */}
        <div id="content-wrapper" className="d-flex flex-column">
          {/* Main Content */}
          <div id="content">
            {/* Topbar */}
            <Navbar navTitle={"Profit Loss"} />
            {/* Begin Page Content */}
            <MarketPLTable />
            {/* /.container-fluid */}
          </div>
          {/* Footer */}
          <Footer />
        </div>
      </div>
      {/* Logout Modal*/}
      <LogoutModel />
    </div>
  )
}

export default MarketPL;
